const BACKEND_URL = (import.meta as any).env.VITE_APP_BACKEND_URL;

let refreshPromise: Promise<boolean> | null = null;

export function clearTokens(): void {
  localStorage.removeItem("oeg_access_token");
  localStorage.removeItem("oeg_refresh_token");
}

export async function attemptRefresh(): Promise<boolean> {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/auth/refresh`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });

      if (!res.ok) {
        return false;
      }

      return true;
    } catch {
      return false;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
}
